import { FaExpand } from "react-icons/fa";
import styled, { css } from "styled-components";

const FocusIndicatorWrapper = styled("div")`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px;
  z-index: 5;
  background-color: #14141471;
  ${(props) =>
    props.hidden
      ? css`
          display: none;
        `
      : css`
          display: flex;
          cursor: pointer;
        `}
`;

interface IFocusIndicatorProps {
  show: boolean;
  handleChangeFocused: () => void;
}

const FocusIndicator = ({
  show,
  handleChangeFocused,
}: IFocusIndicatorProps) => {
  return (
    <FocusIndicatorWrapper
      id="focus-indicator"
      hidden={show}
      onClick={handleChangeFocused}
    >
      <FaExpand size={25} fill="white" />
    </FocusIndicatorWrapper>
  );
};

export default FocusIndicator;
